import _objectSpread from "/var/www/web-feedback/form-builder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { DEBUG_BUILD } from './debug-build.js';
import { isThenable } from './utils-hoist/is.js';
import { logger } from './utils-hoist/logger.js';
import { SyncPromise } from './utils-hoist/syncpromise.js';

/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */
function notifyEventProcessors(processors, event, hint) {
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return new SyncPromise(function (resolve, reject) {
    var processor = processors[index];
    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      var result = processor(_objectSpread({}, event), hint);
      DEBUG_BUILD && processor.id && result === null && logger.log("Event processor \"".concat(processor.id, "\" dropped event"));
      if (isThenable(result)) {
        void result.then(function (final) {
          return notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
        }).then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
      }
    }
  });
}
export { notifyEventProcessors };